module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/badges_png/reward_gift_badge-b3502b1f72d810b1e33264ce13c13eb8.png";